import React, { useEffect, useState } from "react";
import fire from "../../imagesHome/fire.gif";

import './StreakDisplay.css';


const days = ["Lu", "Ma", "Mi", "Jo", "Vi"];

export default function StreakDisplay({ streak = 1 }) {
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    days.forEach((_, i) => {
      setTimeout(() => setVisibleCount((c) => c + 1), 200 * (i + 1));
    });
  }, []);

  return (
    <div className="streak-wrapper">

      <img src={fire} alt="fire" className="streak-fire-big" />

      <div className="streak-number">{streak}</div>
      <div className="streak-label">zile in serie</div>

      <div className="streak-days-container">
        {days.map((day, i) => (
          <div
            key={i}
            className={
              "streak-day-bubble " +
              (i < streak ? "active " : "") +
              (i < visibleCount ? "visible" : "")
            }
          >
            {day}
          </div>
        ))}
      </div>

      <p className="streak-warning">
        Exerseaza zilnic ca sa nu pierzi seria!
      </p>

    </div>
  );
}
